// src/components/course/ProgressSidebar.jsx
import React from 'react';
import { IoClose } from 'react-icons/io5';
import ProgressItem from './ProgressItem';

const ProgressSidebar = ({ isOpen, onClose, sections, currentSection, canAccessSection, onSectionSelect }) => (
  <div
    className={`
      fixed inset-y-0 left-0 w-64 bg-white z-50 transform transition-transform duration-300 ease-in-out shadow-xl border-r border-slate-200
      ${isOpen ? 'translate-x-0' : '-translate-x-full'}
      md:hidden
    `}
  >
    {/* Overlay */}
    {isOpen && (
      <div
        className="fixed inset-0 bg-slate-900/40 backdrop-blur-sm z-40"
        onClick={onClose}
      />
    )}

    {/* Sidebar Content */}
    <div className="relative z-50 h-full overflow-y-auto">
      <div className="flex justify-between items-center px-4 py-3.5 border-b border-slate-200">
        <h2 className="text-sm font-bold text-slate-800 uppercase tracking-wider">Course Progress</h2>
        <button
          onClick={onClose}
          className="p-1.5 rounded-lg text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-colors"
        >
          <IoClose size={18} />
        </button>
      </div>

      {sections.map((section) => (
        <ProgressItem
          key={section.id}
          title={section.title}
          progress={section.progress}
          isAIEnabled={section.isAIEnabled}
          isActive={currentSection === section.order + 1}
          isLocked={false}
          type={section.type}
          isCollapsed={false}
          order={section.order}
          onClick={() => {
            onSectionSelect(section.order + 1);
            onClose();
          }}
        />
      ))}
    </div>
  </div>
);

export default ProgressSidebar;
